var map = {
	"./search-results.de-CH.json": 1003,
	"./search-results.de-DE.json": 1004,
	"./search-results.en-CA.json": 1005,
	"./search-results.en-GB.json": 1006,
	"./search-results.en-IN.json": 1007,
	"./search-results.en-ME.json": 1008,
	"./search-results.en-US.json": 1009,
	"./search-results.es-EM.json": 1010,
	"./search-results.es-ES.json": 1011,
	"./search-results.fr-BE.json": 1012,
	"./search-results.fr-CA.json": 1013,
	"./search-results.fr-CH.json": 1014,
	"./search-results.nl-BE.json": 1015,
	"./search-results.nl-NL.json": 1016,
	"./search-results.pl-PL.json": 1017,
	"./search-results.pt-BR.json": 1018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1002;